
import React from 'react';

const features = [
  {
    title: "IA na aprendizagem",
    description: "O uso de Inteligência Artificial será essencial para aprimorar e facilitar o processo de aprendizado, acelerando a compreensão de problemas reais, para então compreender quais competências serão necessárias para solucioná-los e guiar você a desenvolvê-las.",
    icon: (
      <svg className="w-6 h-6 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    )
  },
  {
    title: "Nossa história no Ensino",
    description: "Passamos 4 anos criando propostas de ensino à distância, impactando mais de 7000 pessoas em diversos países de lingua portuguesa. Desenvolvendo e aperfeiçoando diversas competências da área de tecnologia, além de possibilitar um caminho da transição de carreira.",
    icon: (
      <svg className="w-6 h-6 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    )
  },
  {
    title: "Life Long Learning",
    description: "O aprendizado não precisa ter um fim. Nosso ecossistema busca expandir sua curiosidade e torná-la contínua além de trazer uma constante atualização profissional, te mantendo longe da estagnação nos estudos.",
    icon: (
      <svg className="w-6 h-6 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
      </svg>
    )
  }
];

export const Features: React.FC = () => {
  return (
    <section id="features" className="py-24 px-4 bg-slate-900/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-4">A solução para o seu aprendizado</h2>
          <p className="text-slate-400 max-w-4xl mx-auto text-lg">
            Com nossa experiência em gerar soluções de ensino, estamos dando o próximo passo para aprimorar a qualidade da aprendizagem.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, idx) => (
            <div key={idx} className="glass p-8 rounded-3xl border border-indigo-500/20 hover:border-indigo-500/40 hover:translate-y-[-8px] transition-all duration-300 group shadow-2xl">
              <div className={`w-12 h-12 bg-indigo-600/20 border border-indigo-500/30 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-black/20 group-hover:scale-110 transition-transform`}>
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
              <p className="text-slate-400 leading-relaxed text-sm">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
